import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

import { Notification, Configuration } from './models/notificacion';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Procurator } from './models/procurator';


@Injectable()
export class NotificationCidiService {

    searchText = '';
    notifications: Notification[];


    onNotificationsChanged: BehaviorSubject<any>;
    currentNotification: Notification;
    onCurrentNotificationChanged: BehaviorSubject<any>;
    onSearchTextChanged: BehaviorSubject<any>;
    routeParams: any;

    pageReceived: any;
    onPageReceivedChanged: BehaviorSubject<any>;
    pageSent: any;
    onPageSentChanged: BehaviorSubject<any>;

    configuration: Configuration;
    onConfigurationChanged: BehaviorSubject<any>;

    constructor(private http: HttpClient) {
      this.onCurrentNotificationChanged = new BehaviorSubject(undefined);
      this.onNotificationsChanged = new BehaviorSubject([]);
      this.onSearchTextChanged = new BehaviorSubject('');

      this.pageReceived = {
        pageNumber: 0,
        size: 10,
        search_term: '',
        filter: 'a'
      };
      this.onPageReceivedChanged = new BehaviorSubject(this.pageReceived);

      this.pageSent = {
        pageNumber: 0,
        size: 10,
        search_term: ''
      };
      this.onPageSentChanged = new BehaviorSubject(this.pageSent);

      this.configuration = {
        id_user: null,
        event_config: [],
        methods: {},
        show_config: false
      };
      this.onConfigurationChanged = new BehaviorSubject(this.configuration);
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
      this.routeParams = route.params;


        return new Promise((resolve, reject) => {
          Promise.all([
            this.getNotifications()
          ]).then(
            () => {
              if ( this.routeParams.notificationId ) {
                this.setCurrentNotification(this.routeParams.notificationId);
              } else {
                this.setCurrentNotification(null);
              }

              this.onSearchTextChanged.subscribe(searchText => {
                this.searchText = searchText;
                this.pageReceived.filter = searchText;
                this.pageSent.filter = searchText;
                this.pageReceived.pageNumber = 0;
                this.pageSent.pageNumber = 0;
                this.getNotifications();
              });

              resolve(resolve);
            },
            reject
          );
        });

    }



    getNotifications(): Promise<Notification[]> {
      return this.getNotificationByFolders(this.routeParams.folderHandle);
    }


    getConfigCidi() {
      return this.http.get(`${environment.BACKEND}notificacion_cidi/getCidiConfig`);
    }


    getNotificationByFolders(handle): Promise<Notification[]> {
      return new Promise((resolve, reject) => {
        if (handle === 'recibido') {
          const httpParams = {
            fromObject: this.pageReceived
          };
          this.http.post<any>(`${environment.BACKEND}notificacion_cidi/getNotificaciones`, this.pageReceived)
          .subscribe(data => {
            this.notifications = data.response.data;
            this.pageReceived = data.response.page;
            this.onNotificationsChanged.next(this.notifications);
            this.onPageReceivedChanged.next(this.pageReceived);
            resolve(this.notifications);
          }, reject);
        }

      });
    }

    createNotification(value) {
      return this.http.post(`${environment.BACKEND}notificacion_cidi/create`, value);
    }


    getUserCuil(value) {
      return this.http.get(`${environment.BACKEND}notificacion_cidi/getUserCuil/${value}`);
    }

    getComprobante(id){
      return this.http.get(`${environment.BACKEND}notificacion_cidi/downloadComprobante/${id}`, { responseType: 'blob' });
    }




    setCurrentNotification(id): void {
      this.notifications.map(
        notifacation=>{
          notifacation.CIDI_MENSAJE = notifacation.CIDI_MENSAJE ? notifacation.CIDI_MENSAJE.replace(/"/g, '') : notifacation.MENSAJE;
        }
      )
      this.currentNotification = this.notifications.find(notification => {
        return notification.ID === id || notification.ID_BODY === id;
      });

      this.onCurrentNotificationChanged.next(this.currentNotification);
    }



    setPage(page) {
      let obj = {};
      this.routeParams.folderHandle === 'recibido' ?
        this.pageReceived.pageNumber = page.pageNumber :
        this.pageSent.pageNumber = page.pageNumber;
      this.getNotifications().then(obj = this.getPage());
      return obj;
    }

    getPage() {
      let obj;
      this.routeParams.folderHandle === 'recibido' ? obj = this.pageReceived : obj = this.pageSent;
      obj = {
        size: parseInt(obj.size, 10),
        totalElements: parseInt(obj.totalElements, 10),
        totalPages: parseInt(obj.totalPages, 10),
        pageNumber: parseInt(obj.pageNumber, 10)
      };
      return obj;
    }


}
